import { Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { HealthStatus } from '../../../services/health/health.model';
import { StatusIndicatorComponent } from 'htx-ui-library';

@Component({
  selector: 'app-dashboard-card',
  imports: [NgOptimizedImage, TranslocoDirective, StatusIndicatorComponent],
  templateUrl: './dashboard-card.component.html',
  styleUrl: './dashboard-card.component.scss'
})
export class DashboardCardComponent {
  systemKey = input<string>();

  healthStatus = input<HealthStatus>('DOWN');
}
